import * as React from 'react';
import {
  DrawerProps,
  Wrapper,
  DownIcon,
  PreviewTitle,
  Image,
  Content,
  Heading,
  Paragraph,
  Container,
} from './index.style';
import { Button } from '@lendi-ui/button';
import { eventTracking } from '../../utils';
import getConfig from 'next/config';

const title = 'Is your low fixed rate coming to an end?';
const { publicRuntimeConfig } = getConfig();

const Drawer = ({ show, toggleDrawer }: DrawerProps) => {
  const { ASSET_PREFIX } = publicRuntimeConfig;
  return (
    <Wrapper show={show}>
      <DownIcon color="shade.0" onClick={toggleDrawer} />
      <PreviewTitle>{title}</PreviewTitle>
      <Container>
        <Image
          src={`${ASSET_PREFIX}images/image.jpg`}
          srcSet={`${`${ASSET_PREFIX}images/image.jpg`} 1x, ${`${ASSET_PREFIX}images/image@2x.jpg`} 2x`}
        />
        <Content>
          <Heading>{title}</Heading>
          <Paragraph>Search competitive rates in minutes and find the right one for you.</Paragraph>
          <Button
            variant="emphasis"
            size="sm"
            onClick={() => {
              eventTracking('above-fold', 'navigate', 'Compare rates');
              window.location.href = '/home-loans/basics/refinance/loan-amount' + window.location.search;
            }}
          >
            Compare rates
          </Button>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default Drawer;
